// extracted by mini-css-extract-plugin
export default {"tabs":"index_tabs__-DrJ6","tab":"index_tab__ynjN-","line":"index_line__58K35","item":"index_item__zTz+Q","active":"index_active__Towib","nums":"index_nums__G9fmY"};